import {DICT_KEY, getModel, setModel,refreshDict} from "../../../utils/constants";
import CustomerService from "./CustomerService";
import ModelUtils from "../../../utils/ModelUtils";

const MODEL_KEY = DICT_KEY.BASE_CUSTOMER;
const storageModel = getModel(MODEL_KEY);

const customerModel = {
    state: storageModel ? storageModel : {
        searchParam: null,
        selectedTypeNode: null,
        customerList: [],
        pageInfo: {
            total:0,
            pageNum:1
        },
        accountList: [],
        selectedCustomer: null,
        selectedCustomerRowKeys: [],
        selectedAccount: null,
        selectedAccountRowKeys: [],

        adjustModelVisible: false,
        fillModelVisible: false,
        transferModelVisible: false,
        tabsKey:null,        
        tabsList:[],
        tabParams:null,
        tabPage:{}
    },

    reducers: {
        setSearchParam(state, payload) {
            // console.log(payload)
            state.searchParam = {...payload};
        },
        setSelectedTypeNode(state, payload) {
            state.selectedTypeNode = payload;
            setModel(MODEL_KEY, {...state});
        },

        setCustomerList(state, payload) {
            state.customerList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPageInfo(state, payload) {
            state.pageInfo = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAccountList(state, payload) {
            state.accountList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedCustomer(state, payload) {
            state.selectedCustomer = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedCustomerRowKeys(state, payload) {
            state.selectedCustomerRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedAccount(state, payload) {
            state.selectedAccount = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedAccountRowKeys(state, payload) {
            state.selectedAccountRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAdjustModelVisible(state, payload) {
            state.adjustModelVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setFillModelVisible(state, payload) {
            state.fillModelVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTransferModelVisible(state, payload) {
            state.transferModelVisible = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTabsKey(state,payload){
            state.tabsKey = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabsList(state,payload){
            state.tabsList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTabParams(state,payload){
            state.tabParams = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabPage(state,payload){
            state.tabPage = payload;
        }
    },
    effects: (dispatch) => ({
        async loadCustomerList({showMsg = true, duration = 5, data}) {
            const funName = "加载客户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.pageSize =data.pageSize|| 15
            data.pageNum =data.pageNum|| 1
            const func = async () => {
                let retData = await CustomerService.findPage(data);
                // console.log(retData)
                const {list, ...page} = retData;
                // console.log(retData,list)
                list.forEach(el => el.key = el.id);
                this.setCustomerList(list);
                this.setPageInfo(page);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadCustomerAccountList({showMsg = true, duration = 5, data}) {
            const funName = "加载客户账户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log(data)
            const func = async () => {
                let retData = await CustomerService.findAccountAll(data);
                let {list,statistic} = retData[0]
                list.forEach(el => el.key = el.id);

                this.setAccountList(list);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async insert({showMsg = true, duration = 5, ...data}) {
            const funName = "新增客户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.insert(data);
                const {cmDict} = dispatch;
                await refreshDict("CUSTOMER", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async update({showMsg = true, duration = 5, ...data}) {
            const funName = "更新客户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.update(data);
                const {cmDict} = dispatch;
                await refreshDict("CUSTOMER", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async enableOrDisableCustomer({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "更新客户状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {record, checked} = data;
            //调用接口
            const func = async () => {
                let retData = await CustomerService.enableOrDisable({...record, customerStatus: checked ? 0 : 1});
                //更新本地数据
                const {cmDict} = dispatch;
                await refreshDict("CUSTOMER", cmDict);
                const {customerList} = customer;
                const mapCustomerList = customerList.map(el => {
                    if (el.id === record.id) {
                        return {...el, customerStatus: checked ? 0 : 1}
                    }
                    return el;
                });
                this.setCustomerList(mapCustomerList);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async enableOrDisableAccount({showMsg = true, duration = 5,data}, {customer}) {
            const funName = "更新客户账户状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {id, accountStatus} = data;
            // console.log(accountCode,checked)
            // let code = record.accountCode;
            // let checkeds = checked?0:1
            // return console.log(data)
            //调用接口
            const func = async () => {
                let retData = await CustomerService.accountEnableOrDisable(data);
                const {cmDict} = dispatch;
                await refreshDict("CUSTOMER", cmDict);
                //更新本地数据
                const {accountList} = customer;
                const mapAccList = accountList.map(el => {
                    if (el.id === id) {
                        return {...el, accountStatus: accountStatus ? 1 : 0}
                    }
                    return el;
                }); 
                this.setAccountList(mapAccList);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async adjustAccount({showMsg = true, duration = 5, datas}, {customer}) {
            const funName = "调整授信额度";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(datas)
            const func = async () => {
                let retData = await CustomerService.adjustAccount(datas);

                //重新加载客户账户
                const {selectedCustomer} = customer;
                await this.loadCustomerAccountList({showMsg: false, data: selectedCustomer.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async fillAccount({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "账户充值";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.fillAccount(data);

                //重新加载客户账户
                const {selectedCustomer} = customer;
                await this.loadCustomerAccountList({showMsg: false, data: selectedCustomer.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async transferAccount({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "账户转账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await CustomerService.transferAccount(data);

                //重新加载客户账户
                const {selectedCustomer} = customer;
                await this.loadCustomerAccountList({showMsg: false, data: selectedCustomer.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async SupplierResizeLimitList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "调额记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierResizeLimitList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载转账记录
        async SupplierTransferAccountsList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "加载转账记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierTransferAccountsList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载充值记录
        async SupplierRechargeList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "充值记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await CustomerService.SupplierRechargeList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabPage(page)
                this.setTabsList(list);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
}


export default customerModel;